import { render, staticRenderFns } from "./BuyClicksGroup.vue?vue&type=template&id=67c6ed39&scoped=true"
import script from "./BuyClicksGroup.vue?vue&type=script&lang=js"
export * from "./BuyClicksGroup.vue?vue&type=script&lang=js"
import style0 from "./BuyClicksGroup.vue?vue&type=style&index=0&id=67c6ed39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c6ed39",
  null
  
)

export default component.exports